import { apiUrl1, apiUrl2, apiUrl4 } from "../configs/constant";

export const getSwapTotalData = async () => {
  try {
    const response = await fetch(`${apiUrl2}/bot/swapTotal`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching total swap data:", error);
    throw error;
  }
};

export const getSwapHistoryData = async (address, minTrades, minProfit, minVolume, orderBy, orderDir, limit, offset) => {
  try {
    const response = await fetch(`${apiUrl2}/bot/swapHistoryByAddress?address=${address}&minTrades=${minTrades}&minProfit=${minProfit}&minVolume=${minVolume}&orderBy=${orderBy}&orderDir=${orderDir}&limit=${limit}&offset=${offset}`);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.error("Error fetching swap history data:", error);
    throw error;
  }
}

export const getSwapHistoryDataByAddress = async (address, limit, offset) => {
  try {
    const response = await fetch(`${apiUrl2}/bot/swapHistory/address?address=${address}&limit=${limit}&offset=${offset}`);
    const data = await response.json();
    return data;
  }
  catch (error) {
    console.error("Error fetching swap history data by address:", error);
    throw error;
  }
}

export const fetchRuneMarketData = async (runeTicker) => {
  try {
    const formattedRuneTicker = runeTicker.replace(/[•\s]/g, "");
    const response = await fetch(
      `${apiUrl1}/runes/register`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tickers: [formattedRuneTicker] }),
      }
    );
    if (!response.ok)
      throw new Error(`API error! Status: ${response.status}`);
    const data = await response.json();
    const runeData = data[0];
    return {
      priceFormatted: runeData.priceFormatted ?? "0",
      price: runeData.price ?? "0",
      marketCap: runeData.marketCap ?? "0",
      imageURI: runeData.imageURI ?? "",
      ticker: runeData.ticker,
      name: runeData.name,
      runeNumber: runeData.runeNumber,
      symbol: runeData.symbol,
      totalSupply: runeData.totalSupply,
      divisibility: runeData.divisibility,
      minOrderSize: runeData.minOrderSize,
      maxOrderSize: runeData.maxOrderSize,
      pendingTxnCount: runeData.pendingTxnCount,
      holderCount: runeData.holderCount,
      volume1d: (Number(runeData["volume1d"]) / Math.pow(10, 8)).toFixed(4),
      volume7d: (Number(runeData["volume7d"]) / Math.pow(10, 8)).toFixed(4),
      volume30d: (Number(runeData["volume30d"]) / Math.pow(10, 8)).toFixed(4),
      volumeAll: (Number(runeData["volumeAll"]) / Math.pow(10, 8)).toFixed(4),
      deltaFloor1d: runeData["deltaFloor1d"],
      deltaFloor7d: runeData["deltaFloor7d"],
      deltaFloor30d: runeData["deltaFloor30d"],
      txnCount1d: runeData["txnCount1d"],
      txnCount7d: runeData["txnCount7d"],
      txnCount30d: runeData["txnCount30d"],
    };
  } catch (error) {
    console.error(`Error fetching market data for ${runeTicker}:`, error);
    return null;
  }
};
